export default {
  //* getCampingLingue ---------------------------------------------------------------------------------------------------------------

  //! non credo sia più utile
  async getCampingLingue({ rootGetters }, payload) {
    var tok = "Bearer " + rootGetters["auth/getToken"];
    var base_address = rootGetters["settings/getBaseAddress"];
    var exitStatus = 200;

    var opts = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Access-Control-Allow-Credentials": true,
        "Access-Control-Allow-Origin": "*",
        Accept: "application/json",
        Authorization: tok,
      },
      mode: "cors", // no-cors, *cors, same-origin
    };

    if(payload){
      opts.body = JSON.stringify(payload)
    }

    try {
      await fetch(base_address + "/getCamping/lingue", opts).then(async (response) => {
        if (response.ok) {
          exitStatus = 200;
          exitStatus = await response.json(); // means ok, all right (http protocol)
        } else {
          exitStatus = 400;
          throw new Error();
        }
      });
    } catch (e) {
      console.log(e);
    }
    return exitStatus;
  },

  //* getCampingLingueNoAuth ---------------------------------------------------------------------------------------------------------------

  //! non credo sia più utile
  async getCampingLingueNoAuth({ rootGetters }, payload) {
    var base_address = rootGetters["settings/getBaseAddress"];
    var exitStatus = 200;

    if (!payload.campeggio || payload.campeggio === undefined) {
      return;
    }
    try {
      await fetch(base_address + "/getCamping/lingueNoAuth", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Access-Control-Allow-Credentials": true,
          "Access-Control-Allow-Origin": "*",
          Accept: "application/json",
        },
        mode: "cors", // no-cors, *cors, same-origin
        body: JSON.stringify(payload),
      }).then(async (response) => {
        if (response.ok) {
          exitStatus = 200;
          exitStatus = await response.json(); // means ok, all right (http protocol)
        } else {
          exitStatus = 400;
          throw new Error();
        }
      });
    } catch (e) {
      console.log(e);
    }
    return exitStatus;
  },

  //* setCampingLingue ---------------------------------------------------------------------------------------------------------------

  //! non credo sia più utile
  async setCampingLingue({ rootGetters /*, commit*/ }, payload) {
    var ret_val = 400,
      tok = rootGetters["auth/getToken"],
      base_address = rootGetters["settings/getBaseAddress"];
    // otherwise the patch is not permitted
    tok = "Bearer " + tok; // composition of the token
    await fetch(base_address + "/setCamping/lingue", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Access-Control-Allow-Credentials": true,
        "Access-Control-Allow-Origin": "*",
        Accept: "application/json",
        Authorization: tok,
      },
      mode: "cors", // no-cors, *cors, same-origin
      body: JSON.stringify(payload),
    }).then(async (response) => {
      if (response.ok) {
        ret_val = true; // means ok, all right (http protocol)
      }
    });
    return ret_val;
  },

  //* loadLingueENazioni ---------------------------------------------------------------------------------------------------------------

  async loadLingueENazioni({ rootGetters, commit }, payload) {
    var tok = "Bearer " + rootGetters["auth/getToken"];
    var base_address = rootGetters["settings/getBaseAddress"];
    var response_json = {};

    var opts = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Access-Control-Allow-Credentials": true,
        "Access-Control-Allow-Origin": "*",
        Accept: "application/json",
        Authorization: tok,
      },
      mode: "cors", // no-cors, *cors, same-origin
    };

    if(payload){
      opts.body = JSON.stringify(payload)
    }

    try {
      await fetch(base_address + "/getCampingSettings/getNazioniELingue", opts).then(async (response) => {
        if (response.ok) {
          response_json = await response.json(); // means ok, all right (http protocol)
          // console.log(response_json);
          commit("setLingueENazioni", response_json.data);
        } else {
          throw new Error();
        }
      });
    } catch (e) {
      console.log(e);
    }
    return response_json;
  },

  //* loadLingueENazioniNoAuth ---------------------------------------------------------------------------------------------------------------

  async loadLingueENazioniNoAuth({ rootGetters, commit }, payload) {
    var base_address = rootGetters["settings/getBaseAddress"];
    var response_json = {};
    var body = JSON.stringify(payload);
    // console.log(payload)
    if (!payload.camping || payload.camping === undefined) {
      return;
    }
    try {
      await fetch(
        base_address + "/getCampingSettings/getNazioniELingueNoAuth",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "Access-Control-Allow-Credentials": true,
            "Access-Control-Allow-Origin": "*",
            Accept: "application/json",
          },
          mode: "cors", // no-cors, *cors, same-origin
          body: body,
        }
      ).then(async (response) => {
        if (response.ok) {
          response_json = await response.json(); // means ok, all right (http protocol)
          commit("setLingueENazioni", response_json.data);
        } else {
          throw new Error();
        }
      });
    } catch (e) {
      console.log(e);
    }
    return response_json;
  },

  //* getLocalization ---------------------------------------------------------------------------------------------------------------

  async getLocalization({ rootGetters }, query) {
    var base_address = rootGetters["settings/getBaseAddress"];
    var response_json = {};
    try {
      var id = query.campeggio;
      delete query.campeggio;
      await fetch(base_address + "/getLocalization/" + id, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Access-Control-Allow-Credentials": true,
          "Access-Control-Allow-Origin": "*",
          Accept: "application/json",
        },
        mode: "cors", // no-cors, *cors, same-origin
        body: JSON.stringify(query),
      }).then(async (response) => {
        if (response.ok) {
          response_json = await response.json(); // means ok, all right (http protocol)
          // console.log(response_json);
          return response_json;
        } else {
          throw new Error();
        }
      });
    } catch (e) {
      console.log(e);
    }
    return response_json;
  },

  //* setLocalization ---------------------------------------------------------------------------------------------------------------

  async setLocalization({ rootGetters }, payload) {
    var tok = "Bearer " + rootGetters["auth/getToken"];
    var base_address = rootGetters["settings/getBaseAddress"];
    var response_json = {};
    try {
      await fetch(base_address + "/setLocalization", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Access-Control-Allow-Credentials": true,
          "Access-Control-Allow-Origin": "*",
          Accept: "application/json",
          Authorization: tok,
        },
        mode: "cors", // no-cors, *cors, same-origin
        body: JSON.stringify(payload),
      }).then(async (response) => {
        if (response.ok) {
          response_json = await response.json(); // means ok, all right (http protocol)
          return response_json;
        } else {
          throw new Error();
        }
      });
    } catch (e) {
      console.log(e);
    }
    return response_json;
  },
};
